<template>
  <div class="courseListWrap">
    <Header />
    <van-list
      class="courseList"
      v-model="loading"
      @load="loadMore"
      :finished="finished"
      finished-text="没有更多了"
    >
      <div></div>
      <div class="list_item"
          @click="$router.push({name:'coursedetails',query:{id:vo.id,orgId}})"
          v-for="(vo,i) in courseList.list"
      >
        <div class="imgWrap">
          <van-image fit="cover" :src="vo.cover_img" alt="" lazy-load>
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
          </van-image>
        </div>
        <div class="courseList_info">
          <p class="courseList_info-title ellipsis">{{vo.title}}</p>
          <p class="explain">适合月龄：{{ vo.minimum_month_age }} - {{vo.maximum_month_age}}</p>
          <p class="intro">{{ vo.brief }}</p>
        </div>
      </div>
    </van-list>
    <Footer />
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import state from "@/store/state";
  export default {
    name: "courseList",
    data(){
      return {
        loading:false,
        finished:false
      }
    },
    mounted() {
      let url = document.location.href
      this.wxShare.wxShowMenu('/Home/TinyWebsite/courselist_share',{org_id:this.orgId,url},true)
    },
    methods:{
      loadMore(){
        const page = this.courseList.page + 1 || 1
        this.$ajax('/Home/CourseInpro/index',{page,org_id:this.orgId}).then(res=>{
          if (res.code === 200){
            const totalSize = res.data.total
            const hasNext = this.courseList.list && this.courseList.list.length == totalSize ? false : true
            this.$store.commit('LOADMOREDATA',{data:res.data.list,type:'coursList',page})
            this.loading = false
            hasNext ? this.finished = false : this.finished = true
          }
        })
      },
    },
    computed:{
      ...mapState({
        courseList:state=>state.coursList,
        orgId:state=>state.orgId
      })
    },
    beforeDestroy() {
      this.$store.commit('LOADMOREDATA',{data:[],page:0,type:'coursList',clear:true})
    }
  }
</script>

<style lang="stylus" scoped>
  @import "../static/css/global.styl"
.courseListWrap
  color #333
  font-size 14px
  height calc(100vh - 60px)
  overflow-y auto
  .courseList
    margin-top 10px
    width 100%
    min-height calc(100vh - 60px - 130px - 40px)
    >>>.van-list__finished-text
      width 100%
      font-size 12px
    >>>.van-loading__text
      font-size 12px
    .list_item
      display flex
      background #fff
      padding 0 10px
      justify-content space-between
      width 100%
      margin-bottom 14px
      &:last-child
        margin-bottom 0
      >div
        width 49%
      .imgWrap
        width 168px
        height 96px
        overflow hidden
        display flex
        align-items center
        justify-content center
        border 1px solid #f9f9f9
        img
          width auto
          height 100%
        img[lazy='error'],img[lazy='loading']
          width 50px
          height 50px
      .courseList_info
        padding-top 2px
        .courseList_info-title
          font-size 15px
          color #666
          font-weight 700
        .explain
          line-height 22px
        .intro
          color #999
          font-size 12px
          line-height 17px
          margin-top 6px
          max-height 70px
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;

</style>
